<template>
  <div class="instructions">
    <label class="form-control-label">Instructions</label>
    <draggable 
    v-model="sortedInstructions" 
    class="instructions__container">
      <div
        v-for='(item, index) in sortedInstructions'
        :key='item.id'
        :data-id="index"
        draggable
        @start="startDrag(evt)" 
        @end="onDrop(evt)"
      >
        <div 
          class='drag-el'
        >
          <p class="step list-steps">
            <span class="steps">{{ index + 1 }}</span>
          </p>
          <p class="instruction">
            <i class="fas fa-arrows-alt"></i>
            <html-editor
              v-model="item.instruction">
            </html-editor>  
            <span
              v-on:click="removeInstruction(index)"
              class="shortcut-media avatar rounded-circle bg-gradient-red">
              <i class="fas fa-minus"></i>
            </span>
          </p>
        </div>
      </div>
    </draggable>

    <div class="instructions__add">
      <button
        class="btn base-button btn-secondary"
        v-on:click.prevent="addInstruction"
      >
        Add Instruction
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
import draggable from 'vuedraggable';
import uuid from 'uuid';

export default {
  name: 'InstructionsTable',
  components: {
    HtmlEditor,
    draggable
  },
  props: {
    instructions: []
  },
  data () {
    return {
      instruction: ''
    }
  },
  computed: {
      sortedInstructions: {
        get: function() {
          const savedInstructionsStore = this.$store.state.instructions.saved;
          if ( savedInstructionsStore.length > 0 ) {
            return this.$store.state.instructions.saved
          }
            return []
        },
        set: function(value) {
          this.$store.dispatch('instructions/setSavedInstructions', value)
        },
      }
  },
  created() {
  },
  methods: {
    addInstruction () {
      var step = this.sortedInstructions.length == 0 ? 1 : this.sortedInstructions.length + 1
      var instObj = {}
      instObj.instruction = ''
      instObj.step = step
      instObj.sortOrder = step
      this.sortedInstructions.push(instObj)
      this.$store.dispatch('instructions/setSavedInstructions', this.sortedInstructions)
      this.instruction = ''
    },
    startDrag: (evt) => {
    },
    onDrop (evt) {
    },
    removeInstruction(index){
      this.sortedInstructions.splice(index, 1);
      this.$store.dispatch('instructions/setSavedInstructions', this.sortedInstructions);
    }
  }
}
</script>
<style>
  .quill { width: 89% }
  .rounded-circle { margin-left: 15px; }
</style>